import * as angular from "angular";
import { EffortDataProvider } from "../../../data-provider/effort.dp";
import { Effort } from "../../../models/effort.model";
import { DialogUtils } from "../../../helper/dialog.helper";

let CanvassEffortComponent = {
    selector: "vcCanvassEffort",
    templateUrl:
        "/angular/components/canvass/modals/canvass-effort.component.html",
    bindings: {
        selectedEffort: "=",
    },
    controller: class CanvassEffortController {
        // * bindings for typescript compiler *
        public selectedEffort: any;
        // ************************************

        private effort: Effort;
        private efforts: Effort[] = [];

        private dialog: DialogUtils;
        private effortDataProvider: EffortDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            EffortDataProvider: EffortDataProvider
        ) {
            this.dialog = DialogUtils;

            this.effortDataProvider = EffortDataProvider;
        }

        $onInit() {
            this.effort = this.selectedEffort;

            this.effortDataProvider
                .getActiveEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts;
                    if (this.selectedEffort) {
                        angular.forEach(this.efforts, (effort) => {
                            if (effort.id == this.selectedEffort.id) {
                                this.effort = effort;
                            }
                        });
                    }
                });
        }

        confirm(): void {
            this.dialog.hide(this.effort);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("canvass")
    .component(CanvassEffortComponent.selector, CanvassEffortComponent);
